// extracted by mini-css-extract-plugin
export default {"container":"Jxr2P5PEp5MOLI8im9G0"};